export const pallete: [string, string][] = [
  ["#06d3fe", "#0758a7"],
  ["#9ae6f3", "#1a4869"],
  ["#ffcc00", "#707070"],
  ["#e78c9b", "#65005e"],
];
